module.exports = __webpack_public_path__ + "img/level_4d.ff06b87f.png";